import React from "react";
import styles from "./style.module.css";
import { useTranslation } from "react-i18next";

const LoanStatus = ({ status }) => {
  const { t } = useTranslation("notification");
  if (status === "draft") {
    return (
      <div className={styles.container}>
        <div className={styles.pendingIcon}></div>
        <p className={styles.pending}>{t("checkPaper")}</p>
      </div>
    );
  }
  return null;
};

export default LoanStatus;
